"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let ContractService = class ContractService extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    item;
    async $$load_item() {
        return this.$fn.fetch('read_contract_service', { parameters: { id: this.oid }, asResource: true });
    }
    labelAlign;
    billingCategories;
    async $$load_billingCategories() {
        return this.$fn.fetch('get_tags', { parameters: { tag_type: 'billing_category' } });
    }
    messages;
    currencies;
    async $$load_currencies() {
        return this.$fn.fetch('list_currency');
    }
    services;
    async $$load_services() {
        return this.$fn.fetch('suggest_product', {
            parameters: { query: '*', top: 50, skip: 0, product_types: 'service', product_invoice_groups: 'all' }
        }).then(data => _.orderBy(data, [p => p.name.toLowerCase()]));
    }
    invoiceGroups;
    async $$load_invoiceGroups() {
        return this.$fn.fetch('list_product_invoice_group');
    }
    ux;
    b_7315092382398562_modalBindings;
    b_5962862420439144_col;
    dataMembers = ['formId', 'item', 'labelAlign', 'billingCategories', 'messages', 'currencies', 'services', 'invoiceGroups', 'ux', 'b_7315092382398562_modalBindings', 'b_5962862420439144_col'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                item: null,
                labelAlign: "right",
                billingCategories: null,
                messages: {
                    addService: {
                        title: this.$fn.pgettext("Contract", "Add Service"),
                    },
                    editService: {
                        title: this.$fn.pgettext("Contract", "Edit Service"),
                    },
                    addServiceFee: {
                        title: this.$fn.pgettext("Contract", "Add Service Fee"),
                    },
                    editServiceFee: {
                        title: this.$fn.pgettext("Contract", "Edit Service Fee"),
                    },
                },
                currencies: null,
                services: null,
                invoiceGroups: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    noPrimaryButton: true,
                    closeButtonText: this.$fn.gettext("Close"),
                    size: "lg",
                },
                b_5962862420439144_col: false,
            },
        };
    }
    get isReadonly() {
        if (this.loaded) {
            return this.item && this.item.isReadonly;
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: [this.item.contract ? this.item.contract.contract_number : null,
                    this.item.snapshot ? this.item.snapshot('name') : null,
                ],
                icon: this.$config.contract.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3798_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_7789867021953041_closeModal_3804_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data,
            },
        };
    }
    async act_7789867021953041_crud_3802_getActionArgs($event) {
        return {
            objectType: "contract_service",
            op: "upsert",
            data: this.item,
            options: {
                parameters: {
                    contract_id: this.item.contract.id,
                },
            },
        };
    }
    async evh_7789867021953041_submit(event, scope) {
        return await this.actions.evh_7789867021953041_submit.executeFromDOM(this, event, scope);
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3798 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3798_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3797 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3798,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3797],
        });
        const act_2248226175642056_closeComponent_3800 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_3799 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_3800,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3799],
        });
        const act_7789867021953041_closeModal_3804 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7789867021953041_closeModal_3804_getActionArgs,
            events: [],
        });
        const evh_7789867021953041_success_3803 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_closeModal_3804,
            event: "success",
            displayName: "closeModal",
        });
        const act_7789867021953041_crud_3802 = new core_1.actions.CRUDAction({
            actionArgs: this.act_7789867021953041_crud_3802_getActionArgs,
            displayName: "save",
            events: [evh_7789867021953041_success_3803],
        });
        const evh_7789867021953041_submit_3801 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_crud_3802,
            event: "submit",
            displayName: "save",
        });
        const evh_7789867021953041_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7789867021953041_submit_3801],
        });
        const act_1548630417156826_closeComponent_3806 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1548630417156826_clickPreventStop_3805 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeComponent_3806,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_3805],
        });
        return {
            act_7315092382398562_closeModal_3798,
            evh_7315092382398562_close_3797,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_3800,
            evh_2248226175642056_close_3799,
            evh_2248226175642056_close,
            act_7789867021953041_closeModal_3804,
            evh_7789867021953041_success_3803,
            act_7789867021953041_crud_3802,
            evh_7789867021953041_submit_3801,
            evh_7789867021953041_submit,
            act_1548630417156826_closeComponent_3806,
            evh_1548630417156826_clickPreventStop_3805,
            evh_1548630417156826_clickPreventStop,
            save: act_7789867021953041_crud_3802,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], ContractService.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractService.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], ContractService.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractService.prototype, "onSize", null);
ContractService = __decorate([
    (0, vue_property_decorator_1.Component)()
], ContractService);
exports.default = ContractService;
vue_property_decorator_1.Vue.component("ContractService", ContractService);
